import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";

const AllApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications title="All Applications" status={[]} stage={[]} />
    </DashboardLayout>
  );
};

export default AllApplications;
